import axiosAuth from "@/services/axiosAuth";
import { useMutation, UseMutationOptions, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { DASHBOARD_PM_REVIEW_ATTACHMENT_API } from "./apiRoutes";

interface ReviewAttachmentPayload {
  action: "PENDING" | "APPROVED" | "REJECTED";
  rejectionReason?: string;
}

interface Props {
  projectId: string;
  taskId: string;
  attachmentId: string;
  payload: ReviewAttachmentPayload;
}

const reviewPmAttachment = async ({ projectId, taskId, attachmentId, payload }: Props): Promise<any> => {
  return await axiosAuth.post(DASHBOARD_PM_REVIEW_ATTACHMENT_API(projectId, taskId, attachmentId), payload);
};

const useReviewPmAttachment = (
  options?: Omit<UseMutationOptions<any, Error, Props>, "mutationFn">
): UseMutationResult<any, Error, Props> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reviewPmAttachment,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["dashboard-pm-client-photos", variables.projectId] });
    },
    ...options,
  });
};

export default useReviewPmAttachment;
